/*foundation init and scripts*/
import './concat/wp-foundation';

/*import custom scripts*/
import './concat/custom-scripts';